<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1200px"
    :before-close="handleClose"
    custom-class="peopleDialog">
    <div class="title" slot="title">
      {{id ? '编辑风险信息' : '添加风险信息'}}
    </div>
  <div class="form-content">
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="ruleFormYan">
      <el-row :gutter="20">
        <el-col :span="12" >
          <el-form-item label="重大变更情况" ref="biangeng_con" prop="biangeng_con">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.biangeng_con" multiple  collapse-tags placeholder="请选择" class="inp">
                <el-option
                  v-for="item in bigbiangengOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在经营异常" ref="is_jingying_yichang" prop="is_jingying_yichang">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_jingying_yichang" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_jingying_yichang == 1">
          <el-form-item label="经营异常情况" ref="jingying_yichang" prop="jingying_yichang">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.jingying_yichang" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在税务异常" ref="is_shuiwu_yichang" prop="is_shuiwu_yichang">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_shuiwu_yichang" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_shuiwu_yichang == 1">
          <el-form-item label="税务异常情况" ref="shuiwu_yichang" prop="shuiwu_yichang">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.shuiwu_yichang" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="失信情况" ref="shixin_con" prop="shixin_con">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.shixin_con" multiple  collapse-tags placeholder="请选择" class="inp">
                <el-option
                  v-for="item in shixinOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="劳动纠纷" ref="laodong_jiufen" prop="laodong_jiufen">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.laodong_jiufen" multiple placeholder="请选择" class="inp">
                <el-option
                  v-for="item in jiufenOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.laodong_jiufen.indexOf(1) != -1">
          <el-form-item label="欠薪信息" ref="qianxian_jiufen" prop="qianxian_jiufen">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.qianxian_jiufen" class="inp">
                <template  slot="append">个月</template>
              </el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.laodong_jiufen.indexOf(2) != -1">
          <el-form-item label="社保欠缴信息" ref="shebao_jiufen" prop="shebao_jiufen">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.shebao_jiufen" class="inp">
                <template  slot="append">个月</template>
              </el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.laodong_jiufen.indexOf(3) != -1">
          <el-form-item label="欠房租信息" ref="fangzu_jiufen" prop="fangzu_jiufen">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.fangzu_jiufen" class="inp">
                <template  slot="append">个月</template>
              </el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在资金异动" ref="is_zijin" prop="is_zijin">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_zijin" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zijin == 1">
          <el-form-item label="资金异常情况" ref="zijin_qingkuang" prop="zijin_qingkuang">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.zijin_qingkuang" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在大额资金异动" ref="is_zijin_dae" prop="is_zijin_dae">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_zijin_dae" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zijin_dae == 1">
          <el-form-item label="大额资金异常情况" ref="zijin_dae_qingkuang" prop="zijin_dae_qingkuang">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.zijin_dae_qingkuang" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="舆情信息" ref="is_yuqing" prop="is_yuqing">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_yuqing" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_yuqing == 1">
          <el-form-item label="舆情异常情况" ref="yuqing_qingkuang" prop="yuqing_qingkuang">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.yuqing_qingkuang" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12" >-->
<!--          <el-form-item label="是否存在违规情况" ref="weigui_con" prop="weigui_con">-->
<!--            <div class="flex justify-start align-center">-->
<!--              <el-select v-model="ruleForm.weigui_con" placeholder="请选择" class="inp">-->
<!--                <el-option-->
<!--                  v-for="item in isYes"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </div>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="12">
          <el-form-item label="是否存在违规情况" ref="weigui_con" prop="weigui_con">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.weigui_con" multiple  collapse-tags placeholder="请选择" class="inp">
                <el-option
                  v-for="item in weiguiOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在涉诉情况" ref="is_shesu" prop="is_shesu">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_shesu" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_shesu == 1">
          <el-form-item label="涉诉情况" ref="shesu_con" prop="shesu_con">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.shesu_con" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在重大安全隐患" ref="is_zhongda_yinhuan" prop="is_zhongda_yinhuan">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_zhongda_yinhuan" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zhongda_yinhuan == 1">
          <el-form-item label="重大安全隐患具体情况" ref="zhongda_yinhuan" prop="zhongda_yinhuan">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.zhongda_yinhuan" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在其他风险信息" ref="other" prop="other">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.other" multiple  collapse-tags placeholder="请选择" class="inp">
                <el-option
                  v-for="item in otherFengxianOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在资金监管风险信息" ref="is_zijinfengxian" prop="is_zijinfengxian">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_zijinfengxian" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_zijinfengxian == 1">
          <el-form-item label="资金监管风险信息具体情况" ref="zijin_jianguan_fengxian" prop="zijin_jianguan_fengxian">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.zijin_jianguan_fengxian" multiple  collapse-tags placeholder="请选择" class="inp">
                <el-option
                  v-for="item in jianguanFengxianOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在平台信息错报漏报" ref="pingtai_loubao" prop="pingtai_loubao">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.pingtai_loubao" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.pingtai_loubao == 1">
          <el-form-item label="平台信息错报漏报具体情况" ref="loubao_qingkuang" prop="loubao_qingkuang">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.loubao_qingkuang" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="是否存在意识形态问题" ref="is_yishi" prop="is_yishi">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_yishi" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="ruleForm.is_yishi == 1">
          <el-form-item label="意识形态问题具体情况" ref="yishi_wenti" prop="yishi_wenti">
            <div class="flex justify-start align-center">
              <el-input v-model="ruleForm.yishi_wenti" class="inp"></el-input>
            </div>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="btn-box">
      <div class="btn" @click="submitForm('ruleForm')">保存</div>
    </div>
  </div>
  </el-dialog>
</template>
<script>

import {
  bigbiangengOptions,
  isYes, jianguanFengxianOptions, jiufenOptions, otherFengxianOptions, shixinOptions, weiguiOptions
} from "@/utils/const";
import {scrollIntoView} from "@/utils/utils";
import {save_feng,get_feng} from "@/api/admin";
export default {
  name: "supervisionDialog",
  data() {
    return {
      org_id:'',
      isYes: isYes,
      bigbiangengOptions: bigbiangengOptions,
      shixinOptions: shixinOptions,
      jiufenOptions: jiufenOptions,
      weiguiOptions: weiguiOptions,
      otherFengxianOptions: otherFengxianOptions,
      jianguanFengxianOptions: jianguanFengxianOptions,
      ruleForm: {
        biangeng_con: [], // 重大变更情况
        is_jingying_yichang: '', // 是否存在经营异常
        jingying_yichang: '', // 经营异常情况
        is_shuiwu_yichang: '', // 是否存在税务异常
        shuiwu_yichang: '', // 税务异常情况
        shixin_con: [], // 失信情况
        laodong_jiufen: [], // 劳动纠纷
        qianxian_jiufen: '', // 欠薪信息
        shebao_jiufen: '', // 社保欠缴信息
        fangzu_jiufen: '', // 欠房租信息
        is_zijin: '', // 是否存在资金异动
        zijin_qingkuang: '', // 资金异常情况
        is_zijin_dae: '', // 是否存在大额资金异动
        zijin_dae_qingkuang: '', // 大额资金异常情况
        is_yuqing: '', // 舆情信息
        yuqing_qingkuang: '', // 舆情异常情况
        weigui_con: [], // 是否存在违规情况
        is_shesu: '', // 是否存在涉诉情况
        shesu_con: '', // 涉诉情况
        is_zhongda_yinhuan: '', // 是否存在重大安全隐患
        zhongda_yinhuan: '', // 重大安全隐患具体情况
        other: [], // 是否存在其他风险信息
        is_zijinfengxian: '', // 是否存在资金监管风险信息
        zijin_jianguan_fengxian: [], // 资金监管风险信息具体情况
        pingtai_loubao: '', // 是否存在平台信息错报漏报
        loubao_qingkuang: '', // 平台信息错报漏报具体情况
        is_yishi: '', // 是否存在意识形态问题
        yishi_wenti: '', // 意识形态问题具体情况
      },

      rules: {
        loubao_qingkuang: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        yishi_wenti: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        zhongda_yinhuan: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        shesu_con: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        yuqing_qingkuang: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        is_yishi: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        pingtai_loubao: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        zijin_jianguan_fengxian: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_zijinfengxian: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        other: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_zhongda_yinhuan: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_shesu: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        weigui_con: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        zijin_qingkuang: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        fangzu_jiufen: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        shebao_jiufen: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        qianxian_jiufen: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],

        is_zijin_dae: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_yuqing: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_zijin: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        laodong_jiufen: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        shixin_con: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_shuiwu_yichang: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        is_jingying_yichang: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        biangeng_con: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        shuiwu_yichang: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        jingying_yichang: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],

      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
  },
  components: {},
  created() {

  },
  methods: {
    async init(){
      let _data = await get_feng(this.org_id,this.id);
      if(_data.status == 200){
        this.ruleForm = {
          biangeng_con: _data.data.biangeng_con ? _data.data.biangeng_con.split(',').map(Number) : [], // 重大变更情况
          is_jingying_yichang: _data.data.is_jingying_yichang, // 是否存在经营异常
          jingying_yichang: _data.data.jingying_yichang, // 经营异常情况
          is_shuiwu_yichang: _data.data.is_shuiwu_yichang, // 是否存在税务异常
          shuiwu_yichang: _data.data.shuiwu_yichang, // 税务异常情况
          shixin_con: _data.data.shixin_con ? _data.data.shixin_con.split(',').map(Number) : [], // 失信情况
          laodong_jiufen: _data.data.laodong_jiufen ? _data.data.laodong_jiufen.split(',').map(Number) : [], // 劳动纠纷
          qianxian_jiufen: _data.data.qianxian_jiufen, // 欠薪信息
          shebao_jiufen: _data.data.shebao_jiufen, // 社保欠缴信息
          fangzu_jiufen: _data.data.fangzu_jiufen, // 欠房租信息
          is_zijin: _data.data.is_zijin, // 是否存在资金异动
          zijin_qingkuang: _data.data.zijin_qingkuang, // 资金异常情况
          is_zijin_dae: _data.data.is_zijin_dae, // 是否存在大额资金异动
          zijin_dae_qingkuang: _data.data.zijin_dae_qingkuang, // 大额资金异常情况
          is_yuqing: _data.data.is_yuqing, // 舆情信息
          yuqing_qingkuang: _data.data.yuqing_qingkuang, // 舆情异常情况
          weigui_con: _data.data.weigui_con ? _data.data.weigui_con.split(',').map(Number) : [], // 是否存在违规情况
          is_shesu: _data.data.is_shesu, // 是否存在涉诉情况
          shesu_con: _data.data.shesu_con, // 涉诉情况
          is_zhongda_yinhuan: _data.data.is_zhongda_yinhuan, // 是否存在重大安全隐患
          zhongda_yinhuan: _data.data.zhongda_yinhuan, // 重大安全隐患具体情况
          other: _data.data.other ? _data.data.other.split(',').map(Number) : [], // 是否存在其他风险信息
          is_zijinfengxian: _data.data.is_zijinfengxian, // 是否存在资金监管风险信息
          zijin_jianguan_fengxian: _data.data.zijin_jianguan_fengxian ? _data.data.zijin_jianguan_fengxian.split(',').map(Number) : [], // 资金监管风险信息具体情况
          pingtai_loubao: _data.data.pingtai_loubao, // 是否存在平台信息错报漏报
          loubao_qingkuang: _data.data.loubao_qingkuang, // 平台信息错报漏报具体情况
          is_yishi: _data.data.is_yishi, // 是否存在意识形态问题
          yishi_wenti: _data.data.yishi_wenti, // 意识形态问题具体情况
        }
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid, validates) => {
        if (valid) {
          this.submitInfo()
        } else {
          scrollIntoView(this, validates)
        }
      });
    },

    async submitInfo() {
      let _data = await save_feng(
        this.org_id,
      this.id,
        this.ruleForm.biangeng_con.length ? this.ruleForm.biangeng_con.join(',') : '',
        this.ruleForm.is_jingying_yichang,
        this.ruleForm.jingying_yichang,
        this.ruleForm.is_shuiwu_yichang,
        this.ruleForm.shuiwu_yichang,
        this.ruleForm.shixin_con.length ? this.ruleForm.shixin_con.join(',') : '',
        this.ruleForm.laodong_jiufen.length ? this.ruleForm.laodong_jiufen.join(',') : '',
        this.ruleForm.qianxian_jiufen,
        this.ruleForm.shebao_jiufen,
        this.ruleForm.fangzu_jiufen,
        this.ruleForm.is_zijin,
        this.ruleForm.zijin_qingkuang,
        this.ruleForm.is_zijin_dae,
        this.ruleForm.zijin_dae_qingkuang,
        this.ruleForm.is_yuqing,
        this.ruleForm.yuqing_qingkuang,
        this.ruleForm.weigui_con.length ? this.ruleForm.weigui_con.join(',') : '',
        this.ruleForm.is_shesu,
        this.ruleForm.shesu_con,
        this.ruleForm.is_zhongda_yinhuan,
        this.ruleForm.zhongda_yinhuan,
        this.ruleForm.other.length ? this.ruleForm.weigui_con.join(',') : '',
        this.ruleForm.is_zijinfengxian,
        this.ruleForm.zijin_jianguan_fengxian.length ? this.ruleForm.zijin_jianguan_fengxian.join(',') : '',
        this.ruleForm.pingtai_loubao,
        this.ruleForm.loubao_qingkuang,
        this.ruleForm.is_yishi,
        this.ruleForm.yishi_wenti
      );
      if (_data.status == 200) {
        this.$message.success(_data.msg);
        this.handleClose()
      } else {
        this.$message.error(_data.msg);
      }
    },

    handleClose(){
      this.$emit('handleClose',false)
      this.$refs.ruleForm.resetFields()
    },

  },
  watch: {
    dialogVisible(){
      if(this.dialogVisible) {
        this.org_id = this.$route.query.org_id
        if(this.id) {
          this.init()
        }
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.form-content {
  width: 100%;

  .title-flex {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;

    b {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin-right: 10px;
    }
  }


  .width {
    width: 400px;
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px 0;

    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
    }
  }

  .add {
    width: 24px;
    cursor: pointer;
  }


  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
  }

  .btnUp {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }
}

.title-box {
  width: 100%;
  height: 60px;
  border-bottom: solid 2px #e3e7f0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .tit-left {
    display: flex;
    justify-content: flex-start;
    padding-top: 25px;

    img {

    }

    b {
      font-size: 22px;
      color: #16181d;
      font-weight: bold;
      margin-left: 5px;
    }
  }
}
</style>


